export default "__VITE_ASSET__886d7361__"